// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  coreapipath:'https://api.symvasy.veriklick.com/api',
  EncryptKey: 'Synk@1234',
  passwordExpiredays:180,
  passwordExpireAlert:7,
  IsImageViaBtn: false,
  tokenRefreshThreshold: 5 * 60 * 1000,
  ClientLogo: '/assets/images/symvasy.jpg',
  ISDPLogo: '/assets/images/isdp_logo.png',
  DashboardLogo: '/assets/images/FinalDashboard3.png',
  CurrencySign: '$',
  ClientName:'ISDP',
  CompanyName:"ISDP",
  ClientFavIcon:'https://www.virtusa.com/is/image/virtusa/virtusa-favicon?fmt=png-alpha',
  LoggingService:
  {
    ServiceType:"API", //Azure,API
    AzureAppInsights: {
    instrumentationKey: '06d920f9-cb8e-4d08-b116-fe614c4de493',
    disableFetchTracking: false,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true
    }
  },
  commonSetting: {
    emailRegex: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,6}(?:\\.[a-zA-Z]{2,2})?$',
    socialLink: {
      linkedin: '^(https?:\\/\\/)?(www\\.)?linkedin\\.com\\/.*$',
      twitter: '^(https?:\\/\\/)?(www\\.)?twitter\\.com\\/.*$',
      facebook: '^(https?:\\/\\/)?(www\\.)?(facebook\\.com|fb\\.com)\\/.*$'
    },
    dtFormat: 'MMM d, yyyy',
     website: '^(https?:\\/\\/)?(www\\.)?[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\\.[a-z]{2,10}(\\/.*)?$',
     zipRegex: '^[a-zA-Z0-9]+$',
  },
  logging: {
    useSentry: true,
    useAppInsights: false,
    useApi: false,
    sentry: {
      dsn: 'https://994e8172d15db8e637b27ebfe5a8081e@sentry.veriklick.com/7'
    },
    appInsights: {
      instrumentationKey: 'YOUR_AZURE_APP_INSIGHTS_INSTRUMENTATION_KEY'
    },
    apiLogger: {
      endpoint: 'https://prod-api.example.com/logs'
    }
  },
  jobSeeker:
  {
  isPartialLookupAllowed: false,
  initialLoadSettings:
  {
    loadProfile: true,
    loadProfessional: true,
    loadReference: true,
    loadSkill: true,
    loadOther: true,
    loadDocument: true,
   }
  },
  footerCopyrightReserved: '. All Rights Reserved',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
